import React from 'react';
import PropTypes from 'prop-types';
import { renderable } from '../../../PropTypes';

const goBack = () => {
    window.history.back();
};

const CrumbContent = ({ isLink, children }) => (isLink ? <a onClick={goBack}>{children}</a> : <span>{children}</span>);

CrumbContent.propTypes = {
    children: renderable.isRequired,
    isLink: PropTypes.bool,
};

CrumbContent.defaultProps = {
    isLink: false,
};

export default CrumbContent;
